import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from '@bibliocommons/heading';
import { DetailsContainer } from './Details';

import './ResearchAbout.scss';

const ResearchAbout = ({ trackFieldItemClick }) => {
  return (
    <section className="cp-bib-research-about container">
      <div className="row">
        <div className="col-lg-3">
          <Heading tagName="h2" size="moderate" variant>
            <FormattedMessage id="about_section" />
          </Heading>
        </div>
        <div className="col-lg-7">
          <DetailsContainer trackFieldItemClick={trackFieldItemClick} />
        </div>
      </div>
    </section>
  );
};

ResearchAbout.propTypes = {
  trackFieldItemClick: PropTypes.func.isRequired
};

export default ResearchAbout;
